import { c as _c } from "react/compiler-runtime";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventUpdateTitleProps {
  event?: EventRead | null;
}
const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric"
  });
};
export const EventUpdateTitle: React.FC<EventUpdateTitleProps> = t0 => {
  const $ = _c(4);
  const {
    event
  } = t0;
  const t1 = event?.startDate || "";
  let t2;
  if ($[0] !== t1) {
    t2 = formatDate(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className="text-xl font-bold mb-6 text-center">Modifier la réunion du {t2}</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};